// Mock data for Trendsetter Reports

export interface OpportunityReportData {
  date: string
  value: number
  count: number
  status: string
}

export interface ProductReportData {
  name: string
  value: number
  count: number
  format: string
}

export interface OfferReportData {
  date: string
  value: number
  status: string
  media_type: string
}

export interface ContractReportData {
  date: string
  value: number
  status: string
  count: number
}

export interface PaymentAccountReportData {
  name: string
  amount: number
  currency: string
  count: number
}

export interface PaymentAccountByMonthData {
  client: string
  totalAmount: number
  jan: {
    sent: number
    pending: number
    paid: number
    overdue: number
    offersCount: number
    totalAmount: number
    paidAmount: number
  }
  feb: {
    sent: number
    pending: number
    paid: number
    overdue: number
    offersCount: number
    totalAmount: number
    paidAmount: number
  }
  mar: {
    sent: number
    pending: number
    paid: number
    overdue: number
    offersCount: number
    totalAmount: number
    paidAmount: number
  }
  apr: {
    sent: number
    pending: number
    paid: number
    overdue: number
    offersCount: number
    totalAmount: number
    paidAmount: number
  }
  may: {
    sent: number
    pending: number
    paid: number
    overdue: number
    offersCount: number
    totalAmount: number
    paidAmount: number
  }
  jun: {
    sent: number
    pending: number
    paid: number
    overdue: number
    offersCount: number
    totalAmount: number
    paidAmount: number
  }
  jul: {
    sent: number
    pending: number
    paid: number
    overdue: number
    offersCount: number
    totalAmount: number
    paidAmount: number
  }
  aug: {
    sent: number
    pending: number
    paid: number
    overdue: number
    offersCount: number
    totalAmount: number
    paidAmount: number
  }
  sep: {
    sent: number
    pending: number
    paid: number
    overdue: number
    offersCount: number
    totalAmount: number
    paidAmount: number
  }
  oct: {
    sent: number
    pending: number
    paid: number
    overdue: number
    offersCount: number
    totalAmount: number
    paidAmount: number
  }
  nov: {
    sent: number
    pending: number
    paid: number
    overdue: number
    offersCount: number
    totalAmount: number
    paidAmount: number
  }
  dec: {
    sent: number
    pending: number
    paid: number
    overdue: number
    offersCount: number
    totalAmount: number
    paidAmount: number
  }
}

// Opportunities data over time
export const opportunitiesTimeData: OpportunityReportData[] = [
  { date: '2024-01', value: 45000, count: 12, status: 'active' },
  { date: '2024-02', value: 52000, count: 15, status: 'active' },
  { date: '2024-03', value: 48000, count: 14, status: 'active' },
  { date: '2024-04', value: 61000, count: 18, status: 'active' },
  { date: '2024-05', value: 55000, count: 16, status: 'active' },
  { date: '2024-06', value: 67000, count: 20, status: 'active' },
  { date: '2024-07', value: 72000, count: 22, status: 'active' },
  { date: '2024-08', value: 68000, count: 19, status: 'active' },
  { date: '2024-09', value: 75000, count: 23, status: 'active' },
  { date: '2024-10', value: 80000, count: 25, status: 'active' },
  { date: '2024-11', value: 85000, count: 27, status: 'active' },
  { date: '2024-12', value: 90000, count: 30, status: 'active' }
]

// Opportunities by status
export const opportunitiesByStatus = [
  { name: 'Active', value: 245, color: '#52c41a' },
  { name: 'Pending', value: 89, color: '#faad14' },
  { name: 'Closed', value: 156, color: '#1890ff' },
  { name: 'Cancelled', value: 34, color: '#ff4d4f' }
]

// Products by format
export const productsByFormat: ProductReportData[] = [
  { name: 'Billboard', value: 125000, count: 45, format: 'billboard' },
  { name: 'Citylight', value: 98000, count: 38, format: 'citylight' },
  { name: 'Prismatron', value: 156000, count: 28, format: 'prismatron' },
  { name: 'Perete', value: 87000, count: 32, format: 'perete' },
  { name: 'Console', value: 112000, count: 25, format: 'console' },
  { name: 'Ceasuri', value: 134000, count: 19, format: 'ceasuri' }
]

// Offers over time
export const offersTimeData: OfferReportData[] = [
  { date: '2024-01', value: 18500, status: 'approved', media_type: 'video' },
  {
    date: '2024-02',
    value: 22000,
    status: 'approved',
    media_type: 'static_image'
  },
  { date: '2024-03', value: 19800, status: 'pending', media_type: 'video' },
  {
    date: '2024-04',
    value: 24500,
    status: 'approved',
    media_type: 'static_image'
  },
  { date: '2024-05', value: 26700, status: 'active', media_type: 'video' },
  {
    date: '2024-06',
    value: 28900,
    status: 'approved',
    media_type: 'static_image'
  },
  { date: '2024-07', value: 31200, status: 'active', media_type: 'video' },
  {
    date: '2024-08',
    value: 29800,
    status: 'approved',
    media_type: 'static_image'
  },
  { date: '2024-09', value: 33400, status: 'active', media_type: 'video' },
  {
    date: '2024-10',
    value: 35600,
    status: 'approved',
    media_type: 'static_image'
  },
  { date: '2024-11', value: 37800, status: 'active', media_type: 'video' },
  {
    date: '2024-12',
    value: 40100,
    status: 'approved',
    media_type: 'static_image'
  }
]

// Offers by status
export const offersByStatus = [
  { name: 'Approved', value: 145, color: '#52c41a' },
  { name: 'Pending', value: 67, color: '#faad14' },
  { name: 'Active', value: 98, color: '#1890ff' },
  { name: 'Rejected', value: 23, color: '#ff4d4f' },
  { name: 'Expired', value: 12, color: '#8c8c8c' }
]

// Contracts over time
export const contractsTimeData: ContractReportData[] = [
  { date: '2024-01', value: 125000, status: 'signed', count: 8 },
  { date: '2024-02', value: 142000, status: 'signed', count: 9 },
  { date: '2024-03', value: 138000, status: 'pending', count: 7 },
  { date: '2024-04', value: 165000, status: 'signed', count: 11 },
  { date: '2024-05', value: 158000, status: 'signed', count: 10 },
  { date: '2024-06', value: 178000, status: 'signed', count: 12 },
  { date: '2024-07', value: 192000, status: 'signed', count: 13 },
  { date: '2024-08', value: 185000, status: 'pending', count: 11 },
  { date: '2024-09', value: 205000, status: 'signed', count: 14 },
  { date: '2024-10', value: 218000, status: 'signed', count: 15 },
  { date: '2024-11', value: 235000, status: 'signed', count: 16 },
  { date: '2024-12', value: 250000, status: 'signed', count: 18 }
]

// Contracts by status
export const contractsByStatus = [
  { name: 'Signed', value: 156, color: '#52c41a' },
  { name: 'Pending', value: 34, color: '#faad14' },
  { name: 'Draft', value: 28, color: '#1890ff' },
  { name: 'Expired', value: 12, color: '#ff4d4f' },
  { name: 'Cancelled', value: 8, color: '#8c8c8c' }
]

// Payment accounts
export const paymentAccountsData: PaymentAccountReportData[] = [
  { name: 'MDL Account', amount: 450000, currency: 'MDL', count: 89 },
  { name: 'EUR Account', amount: 125000, currency: 'EUR', count: 67 },
  { name: 'USD Account', amount: 89000, currency: 'USD', count: 45 },
  { name: 'RON Account', amount: 234000, currency: 'RON', count: 34 }
]

// Payment accounts by client and month - matching the image
export const paymentAccountsByMonth: PaymentAccountByMonthData[] = [
  {
    client: 'Media Solutions SRL',
    totalAmount: -600,
    jan: {
      sent: 0,
      pending: 0,
      paid: 8,
      overdue: 0,
      offersCount: 2,
      totalAmount: 3500,
      paidAmount: 3500
    },
    feb: {
      sent: 0,
      pending: 0,
      paid: 6,
      overdue: 0,
      offersCount: 1,
      totalAmount: 1200,
      paidAmount: 600
    },
    mar: {
      sent: 0,
      pending: 0,
      paid: 6,
      overdue: 0,
      offersCount: 2,
      totalAmount: 3500,
      paidAmount: 3200
    },
    apr: {
      sent: 0,
      pending: 0,
      paid: 5,
      overdue: 0,
      offersCount: 1,
      totalAmount: 1200,
      paidAmount: 1000
    },
    may: {
      sent: 0,
      pending: 0,
      paid: 7,
      overdue: 0,
      offersCount: 2,
      totalAmount: 3500,
      paidAmount: 3500
    },
    jun: {
      sent: 0,
      pending: 0,
      paid: 4,
      overdue: 0,
      offersCount: 1,
      totalAmount: 1000,
      paidAmount: 800
    },
    jul: {
      sent: 0,
      pending: 0,
      paid: 8,
      overdue: 0,
      offersCount: 2,
      totalAmount: 3500,
      paidAmount: 3500
    },
    aug: {
      sent: 0,
      pending: 0,
      paid: 6,
      overdue: 0,
      offersCount: 2,
      totalAmount: 3500,
      paidAmount: 3300
    },
    sep: {
      sent: 0,
      pending: 0,
      paid: 5,
      overdue: 0,
      offersCount: 1,
      totalAmount: 1200,
      paidAmount: 1100
    },
    oct: {
      sent: 0,
      pending: 0,
      paid: 7,
      overdue: 0,
      offersCount: 2,
      totalAmount: 3500,
      paidAmount: 3500
    },
    nov: {
      sent: 0,
      pending: 0,
      paid: 6,
      overdue: 0,
      offersCount: 2,
      totalAmount: 3500,
      paidAmount: 3400
    },
    dec: {
      sent: 0,
      pending: 0,
      paid: 8,
      overdue: 0,
      offersCount: 2,
      totalAmount: 3500,
      paidAmount: 3500
    }
  },
  {
    client: 'Outdoor Advertising MD',
    totalAmount: -900,
    jan: {
      sent: 0,
      pending: 0,
      paid: 3,
      overdue: 0,
      offersCount: 1,
      totalAmount: 600,
      paidAmount: 300
    },
    feb: {
      sent: 0,
      pending: 0,
      paid: 0,
      overdue: 0,
      offersCount: 1,
      totalAmount: 600,
      paidAmount: 0
    },
    mar: {
      sent: 0,
      pending: 0,
      paid: 2,
      overdue: 0,
      offersCount: 1,
      totalAmount: 600,
      paidAmount: 400
    },
    apr: {
      sent: 0,
      pending: 0,
      paid: 1,
      overdue: 0,
      offersCount: 1,
      totalAmount: 600,
      paidAmount: 200
    },
    may: {
      sent: 0,
      pending: 0,
      paid: 3,
      overdue: 0,
      offersCount: 1,
      totalAmount: 600,
      paidAmount: 500
    },
    jun: {
      sent: 0,
      pending: 0,
      paid: 2,
      overdue: 0,
      offersCount: 1,
      totalAmount: 600,
      paidAmount: 350
    },
    jul: {
      sent: 0,
      pending: 0,
      paid: 4,
      overdue: 0,
      offersCount: 1,
      totalAmount: 600,
      paidAmount: 600
    },
    aug: {
      sent: 0,
      pending: 0,
      paid: 1,
      overdue: 0,
      offersCount: 1,
      totalAmount: 600,
      paidAmount: 150
    },
    sep: {
      sent: 0,
      pending: 0,
      paid: 3,
      overdue: 0,
      offersCount: 1,
      totalAmount: 600,
      paidAmount: 450
    },
    oct: {
      sent: 0,
      pending: 0,
      paid: 2,
      overdue: 0,
      offersCount: 1,
      totalAmount: 600,
      paidAmount: 300
    },
    nov: {
      sent: 0,
      pending: 0,
      paid: 4,
      overdue: 0,
      offersCount: 1,
      totalAmount: 600,
      paidAmount: 550
    },
    dec: {
      sent: 0,
      pending: 0,
      paid: 3,
      overdue: 0,
      offersCount: 1,
      totalAmount: 600,
      paidAmount: 500
    }
  },
  {
    client: 'Digital Media Pro',
    totalAmount: 0,
    jan: {
      sent: 0,
      pending: 0,
      paid: 5,
      overdue: 0,
      offersCount: 5,
      totalAmount: 6000,
      paidAmount: 5000
    },
    feb: {
      sent: 0,
      pending: 0,
      paid: 4,
      overdue: 0,
      offersCount: 2,
      totalAmount: 3500,
      paidAmount: 4500
    },
    mar: {
      sent: 0,
      pending: 0,
      paid: 6,
      overdue: 0,
      offersCount: 3,
      totalAmount: 4500,
      paidAmount: 5000
    },
    apr: {
      sent: 0,
      pending: 0,
      paid: 5,
      overdue: 0,
      offersCount: 4,
      totalAmount: 5500,
      paidAmount: 5500
    },
    may: {
      sent: 0,
      pending: 0,
      paid: 7,
      overdue: 0,
      offersCount: 2,
      totalAmount: 3500,
      paidAmount: 4000
    },
    jun: {
      sent: 0,
      pending: 0,
      paid: 4,
      overdue: 0,
      offersCount: 3,
      totalAmount: 4500,
      paidAmount: 4500
    },
    jul: {
      sent: 0,
      pending: 0,
      paid: 8,
      overdue: 0,
      offersCount: 2,
      totalAmount: 3500,
      paidAmount: 4000
    },
    aug: {
      sent: 0,
      pending: 0,
      paid: 6,
      overdue: 0,
      offersCount: 4,
      totalAmount: 5500,
      paidAmount: 6000
    },
    sep: {
      sent: 0,
      pending: 0,
      paid: 5,
      overdue: 0,
      offersCount: 3,
      totalAmount: 4500,
      paidAmount: 5000
    },
    oct: {
      sent: 0,
      pending: 0,
      paid: 7,
      overdue: 0,
      offersCount: 2,
      totalAmount: 3500,
      paidAmount: 4000
    },
    nov: {
      sent: 0,
      pending: 0,
      paid: 6,
      overdue: 0,
      offersCount: 3,
      totalAmount: 4500,
      paidAmount: 5000
    },
    dec: {
      sent: 0,
      pending: 0,
      paid: 8,
      overdue: 0,
      offersCount: 2,
      totalAmount: 3500,
      paidAmount: 4000
    }
  },
  {
    client: 'Regional Advertising',
    totalAmount: 0,
    jan: {
      sent: 0,
      pending: 0,
      paid: 7,
      overdue: 0,
      offersCount: 2,
      totalAmount: 3500,
      paidAmount: 3500
    },
    feb: {
      sent: 0,
      pending: 0,
      paid: 7,
      overdue: 0,
      offersCount: 2,
      totalAmount: 3500,
      paidAmount: 3500
    },
    mar: {
      sent: 0,
      pending: 0,
      paid: 7,
      overdue: 0,
      offersCount: 2,
      totalAmount: 3500,
      paidAmount: 3500
    },
    apr: {
      sent: 0,
      pending: 0,
      paid: 7,
      overdue: 0,
      offersCount: 2,
      totalAmount: 3500,
      paidAmount: 3500
    },
    may: {
      sent: 0,
      pending: 0,
      paid: 7,
      overdue: 0,
      offersCount: 2,
      totalAmount: 3500,
      paidAmount: 3500
    },
    jun: {
      sent: 0,
      pending: 0,
      paid: 7,
      overdue: 0,
      offersCount: 2,
      totalAmount: 3500,
      paidAmount: 3500
    },
    jul: {
      sent: 0,
      pending: 0,
      paid: 7,
      overdue: 0,
      offersCount: 2,
      totalAmount: 3500,
      paidAmount: 3500
    },
    aug: {
      sent: 0,
      pending: 0,
      paid: 7,
      overdue: 0,
      offersCount: 2,
      totalAmount: 3500,
      paidAmount: 3500
    },
    sep: {
      sent: 0,
      pending: 0,
      paid: 7,
      overdue: 0,
      offersCount: 2,
      totalAmount: 3500,
      paidAmount: 3500
    },
    oct: {
      sent: 0,
      pending: 0,
      paid: 7,
      overdue: 0,
      offersCount: 2,
      totalAmount: 3500,
      paidAmount: 3500
    },
    nov: {
      sent: 0,
      pending: 0,
      paid: 7,
      overdue: 0,
      offersCount: 2,
      totalAmount: 3500,
      paidAmount: 3500
    },
    dec: {
      sent: 0,
      pending: 0,
      paid: 7,
      overdue: 0,
      offersCount: 2,
      totalAmount: 3500,
      paidAmount: 3500
    }
  },
  {
    client: 'Airport Media',
    totalAmount: -1200,
    jan: {
      sent: 0,
      pending: 0,
      paid: 0,
      overdue: 0,
      offersCount: 1,
      totalAmount: 1000,
      paidAmount: 0
    },
    feb: {
      sent: 0,
      pending: 0,
      paid: 3,
      overdue: 0,
      offersCount: 1,
      totalAmount: 500,
      paidAmount: 300
    },
    mar: {
      sent: 0,
      pending: 0,
      paid: 2,
      overdue: 0,
      offersCount: 1,
      totalAmount: 800,
      paidAmount: 400
    },
    apr: {
      sent: 0,
      pending: 0,
      paid: 1,
      overdue: 0,
      offersCount: 1,
      totalAmount: 600,
      paidAmount: 200
    },
    may: {
      sent: 0,
      pending: 0,
      paid: 3,
      overdue: 0,
      offersCount: 1,
      totalAmount: 500,
      paidAmount: 300
    },
    jun: {
      sent: 0,
      pending: 0,
      paid: 2,
      overdue: 0,
      offersCount: 1,
      totalAmount: 800,
      paidAmount: 400
    },
    jul: {
      sent: 0,
      pending: 0,
      paid: 1,
      overdue: 0,
      offersCount: 1,
      totalAmount: 600,
      paidAmount: 150
    },
    aug: {
      sent: 0,
      pending: 0,
      paid: 4,
      overdue: 0,
      offersCount: 1,
      totalAmount: 500,
      paidAmount: 450
    },
    sep: {
      sent: 0,
      pending: 0,
      paid: 2,
      overdue: 0,
      offersCount: 1,
      totalAmount: 800,
      paidAmount: 350
    },
    oct: {
      sent: 0,
      pending: 0,
      paid: 3,
      overdue: 0,
      offersCount: 1,
      totalAmount: 500,
      paidAmount: 400
    },
    nov: {
      sent: 0,
      pending: 0,
      paid: 1,
      overdue: 0,
      offersCount: 1,
      totalAmount: 600,
      paidAmount: 200
    },
    dec: {
      sent: 0,
      pending: 0,
      paid: 4,
      overdue: 0,
      offersCount: 1,
      totalAmount: 500,
      paidAmount: 500
    }
  },
  {
    client: 'Mall Advertising',
    totalAmount: -700,
    jan: {
      sent: 0,
      pending: 0,
      paid: 7,
      overdue: 0,
      offersCount: 2,
      totalAmount: 3500,
      paidAmount: 3500
    },
    feb: {
      sent: 0,
      pending: 0,
      paid: 3,
      overdue: 0,
      offersCount: 1,
      totalAmount: 1000,
      paidAmount: 300
    },
    mar: {
      sent: 0,
      pending: 0,
      paid: 6,
      overdue: 0,
      offersCount: 2,
      totalAmount: 3500,
      paidAmount: 3200
    },
    apr: {
      sent: 0,
      pending: 0,
      paid: 4,
      overdue: 0,
      offersCount: 1,
      totalAmount: 1000,
      paidAmount: 700
    },
    may: {
      sent: 0,
      pending: 0,
      paid: 7,
      overdue: 0,
      offersCount: 2,
      totalAmount: 3500,
      paidAmount: 3500
    },
    jun: {
      sent: 0,
      pending: 0,
      paid: 5,
      overdue: 0,
      offersCount: 1,
      totalAmount: 1000,
      paidAmount: 800
    },
    jul: {
      sent: 0,
      pending: 0,
      paid: 8,
      overdue: 0,
      offersCount: 2,
      totalAmount: 3500,
      paidAmount: 3500
    },
    aug: {
      sent: 0,
      pending: 0,
      paid: 6,
      overdue: 0,
      offersCount: 2,
      totalAmount: 3500,
      paidAmount: 3300
    },
    sep: {
      sent: 0,
      pending: 0,
      paid: 4,
      overdue: 0,
      offersCount: 1,
      totalAmount: 1000,
      paidAmount: 900
    },
    oct: {
      sent: 0,
      pending: 0,
      paid: 7,
      overdue: 0,
      offersCount: 2,
      totalAmount: 3500,
      paidAmount: 3500
    },
    nov: {
      sent: 0,
      pending: 0,
      paid: 5,
      overdue: 0,
      offersCount: 1,
      totalAmount: 1000,
      paidAmount: 850
    },
    dec: {
      sent: 0,
      pending: 0,
      paid: 8,
      overdue: 0,
      offersCount: 2,
      totalAmount: 3500,
      paidAmount: 3500
    }
  },
  {
    client: 'Digital Displays MD',
    totalAmount: 500,
    jan: {
      sent: 0,
      pending: 0,
      paid: 7,
      overdue: 0,
      offersCount: 2,
      totalAmount: 3500,
      paidAmount: 3500
    },
    feb: {
      sent: 0,
      pending: 0,
      paid: 8,
      overdue: 0,
      offersCount: 2,
      totalAmount: 3500,
      paidAmount: 4000
    },
    mar: {
      sent: 0,
      pending: 0,
      paid: 7,
      overdue: 0,
      offersCount: 2,
      totalAmount: 3500,
      paidAmount: 3600
    },
    apr: {
      sent: 0,
      pending: 0,
      paid: 8,
      overdue: 0,
      offersCount: 2,
      totalAmount: 3500,
      paidAmount: 3800
    },
    may: {
      sent: 0,
      pending: 0,
      paid: 7,
      overdue: 0,
      offersCount: 2,
      totalAmount: 3500,
      paidAmount: 3500
    },
    jun: {
      sent: 0,
      pending: 0,
      paid: 9,
      overdue: 0,
      offersCount: 2,
      totalAmount: 3500,
      paidAmount: 4000
    },
    jul: {
      sent: 0,
      pending: 0,
      paid: 7,
      overdue: 0,
      offersCount: 2,
      totalAmount: 3500,
      paidAmount: 3500
    },
    aug: {
      sent: 0,
      pending: 0,
      paid: 8,
      overdue: 0,
      offersCount: 2,
      totalAmount: 3500,
      paidAmount: 3800
    },
    sep: {
      sent: 0,
      pending: 0,
      paid: 7,
      overdue: 0,
      offersCount: 2,
      totalAmount: 3500,
      paidAmount: 3600
    },
    oct: {
      sent: 0,
      pending: 0,
      paid: 8,
      overdue: 0,
      offersCount: 2,
      totalAmount: 3500,
      paidAmount: 3900
    },
    nov: {
      sent: 0,
      pending: 0,
      paid: 7,
      overdue: 0,
      offersCount: 2,
      totalAmount: 3500,
      paidAmount: 3500
    },
    dec: {
      sent: 0,
      pending: 0,
      paid: 9,
      overdue: 0,
      offersCount: 2,
      totalAmount: 3500,
      paidAmount: 4100
    }
  },
  {
    client: 'City Media Group',
    totalAmount: 0,
    jan: {
      sent: 0,
      pending: 0,
      paid: 7,
      overdue: 0,
      offersCount: 2,
      totalAmount: 3500,
      paidAmount: 3500
    },
    feb: {
      sent: 0,
      pending: 0,
      paid: 7,
      overdue: 0,
      offersCount: 2,
      totalAmount: 3500,
      paidAmount: 3500
    },
    mar: {
      sent: 0,
      pending: 0,
      paid: 7,
      overdue: 0,
      offersCount: 2,
      totalAmount: 3500,
      paidAmount: 3500
    },
    apr: {
      sent: 0,
      pending: 0,
      paid: 7,
      overdue: 0,
      offersCount: 2,
      totalAmount: 3500,
      paidAmount: 3500
    },
    may: {
      sent: 0,
      pending: 0,
      paid: 7,
      overdue: 0,
      offersCount: 2,
      totalAmount: 3500,
      paidAmount: 3500
    },
    jun: {
      sent: 0,
      pending: 0,
      paid: 7,
      overdue: 0,
      offersCount: 2,
      totalAmount: 3500,
      paidAmount: 3500
    },
    jul: {
      sent: 0,
      pending: 0,
      paid: 7,
      overdue: 0,
      offersCount: 2,
      totalAmount: 3500,
      paidAmount: 3500
    },
    aug: {
      sent: 0,
      pending: 0,
      paid: 7,
      overdue: 0,
      offersCount: 2,
      totalAmount: 3500,
      paidAmount: 3500
    },
    sep: {
      sent: 0,
      pending: 0,
      paid: 7,
      overdue: 0,
      offersCount: 2,
      totalAmount: 3500,
      paidAmount: 3500
    },
    oct: {
      sent: 0,
      pending: 0,
      paid: 7,
      overdue: 0,
      offersCount: 2,
      totalAmount: 3500,
      paidAmount: 3500
    },
    nov: {
      sent: 0,
      pending: 0,
      paid: 7,
      overdue: 0,
      offersCount: 2,
      totalAmount: 3500,
      paidAmount: 3500
    },
    dec: {
      sent: 0,
      pending: 0,
      paid: 7,
      overdue: 0,
      offersCount: 2,
      totalAmount: 3500,
      paidAmount: 3500
    }
  }
]

// Total revenue by month
export const revenueByMonth = [
  { month: 'Jan', revenue: 186500, contracts: 125000, offers: 18500 },
  { month: 'Feb', revenue: 214000, contracts: 142000, offers: 22000 },
  { month: 'Mar', revenue: 201800, contracts: 138000, offers: 19800 },
  { month: 'Apr', revenue: 246500, contracts: 165000, offers: 24500 },
  { month: 'May', revenue: 240700, contracts: 158000, offers: 26700 },
  { month: 'Jun', revenue: 284900, contracts: 178000, offers: 28900 },
  { month: 'Jul', revenue: 313200, contracts: 192000, offers: 31200 },
  { month: 'Aug', revenue: 303800, contracts: 185000, offers: 29800 },
  { month: 'Sep', revenue: 338400, contracts: 205000, offers: 33400 },
  { month: 'Oct', revenue: 363600, contracts: 218000, offers: 35600 },
  { month: 'Nov', revenue: 392800, contracts: 235000, offers: 37800 },
  { month: 'Dec', revenue: 420100, contracts: 250000, offers: 40100 }
]

// Media type distribution
export const mediaTypeDistribution = [
  { name: 'Video', value: 234, color: '#1890ff' },
  { name: 'Static Image', value: 187, color: '#52c41a' }
]

// Location performance
export const locationPerformance = [
  { location: 'Chișinău Center', value: 245000, count: 89 },
  { location: 'Airport', value: 189000, count: 67 },
  { location: 'Shopping Mall', value: 156000, count: 54 },
  { location: 'Stadium', value: 134000, count: 45 },
  { location: 'Subway', value: 98000, count: 34 },
  { location: 'Business District', value: 112000, count: 38 }
]
